import { Widget } from "./widget";

export const ErrorMessages = {
  apk: {
    noOffer: "Niestety nie mamy oferty odpowiadającej Twoim potrzebom",
    safeFarmer: "Ta oferta nie odpowiada Twoim potrzebom, zachęcamy do poznania oferty Ubezpieczenia Bezpieczny Rolnik",
    doAnswer: "Zanim przejdziesz dalej, odpowiedz na wszystkie pytania",
    safeEntrepreneur: "Ta oferta nie odpowiada Twoim potrzebom, zachęcamy do poznania oferty Ubezpieczenia Bezpieczny Przedsiębiorca"
  },
  required: "Pole wymagane",
  invalid: "Podana wartość jest nieprawidłowa",
  address: {
    zipCode: "Podany kod pocztowy jest nieprawidłowy"
  },
  client: {
    email: "Podany adres e-mail jest nieprawidłowy",
    phone: "Podany numer telefonu jest nieprawidłowy",
    pesel: "Podany PESEL jest nieprawidłowy",
    lastName: "Podane nazwisko jest nieprawidłowe",
    firstName: "Podane imię jest nieprawidłowe",
    regon: "Podany REGON jest nieprawidłowy",
    nip: "Podany NIP jest nieprawidłowy"
  },
  catAndDog: {
    maxCount: "Łączna liczba zwierząt nie może być większa niż 4",
    zeroCount: "Łączna liczba zwierząt powinna być większa od 0"
  },
  safeSenior: {
    ageUnder60: "Dla osób, które nie ukończyły 60 lat nie jest świadczone ubezpieczenie bezpieczny senior"
  },
  nnw: {
    invalidNumber: "Błędna liczba osób",
    invalidHeartAttackAndStrokeInsuredsCount: "Błędna liczba osób uprawnionych do rozszerzenia zawał i udar",
    ageOver60: "Dla osób, które ukończyły 60 lat nie jest świadczona ochrona w przypadku zawału serca i udaru mózgu",
    tooManyHeartAttackAndStrokeInsured: "Ubezpieczono na zawał i udar o {0} osobę/y więcej niż deklarowano",
    notEnoughHearAttackAndStrokeInsured: "Ubezpieczono na zawał i udar o {0} osobę/y mniej niż deklarowano"

  },
  cession: {
    bank: "Błędna nazwa banku"
  },
  businessActivity: {
    over50percent: "Dla deklarowanej nieruchomości skorzystaj z produktu Bezpieczny Przedsiębiorca Plus. Skontaktuj się z nami 22 327 60 60  lub ze swoim Agentem."
  },
  response: {
    proposal: getDefaultApiErrorMessage("zapisywania wniosku"),
    saveOffer: getDefaultApiErrorMessage("zapisywania oferty"),
    policy: getDefaultApiErrorMessage("wystawiania polisy"),
    generateClientEndsLink: getDefaultApiErrorMessage("generowania linku do dokończenia procesu zakupu"),
    saveCalculation: getDefaultApiErrorMessage("zapisywania kalkulacji"),
    calculation: getDefaultApiErrorMessage("kalkulacji"),
    exceededProxies: "Zawarcie umowy ubezpieczenia wymaga akceptacji.\nPolisa oczekuje na akceptacje TUZ TUW w systemie polisowym Sobol."
  },
  year: {
    earlierThanCurrent: "Podany rok nie może być późniejszy niż rok bieżący"
  },
  renewalPassword: "Niepoprawne hasło"
};

function getDefaultApiErrorMessage(messageSuffix: string) {
  return `Wystąpił błąd przy próbie ${messageSuffix}.\nSpróbuj ponownie później.`;
}

export class ErrorMessage {
  public static scrollToFirstFormErrorMessage() {
    Widget.scrollToClass("error-message");
  }

  public static scrollToFirstErrorMessage() {
    const firstErrorMessage = Widget.getNode("http-message") || Widget.getNode("error-message");
    if (firstErrorMessage) { firstErrorMessage.scrollIntoView({ behavior: "smooth", block: "center" }); }
  }

  public static verifyIfErrorMessageIsRendered() {
    return !!Widget.getNode("error-message") || !!Widget.getNode("http-message");
  }

  public static verifyIfFormErrorMessageIsRendered() {
    return !!Widget.getNode("error-message");
  }

  public static verifyIfHttpMessageIsRendered() {
    return !!Widget.getNode("http-message");
  }

  public static verifyIfFormWithoutClientsDataErrorMessageIsRendered() {
    return !!Widget.getNode("packages-error-message") ||
      this.getErrorMessageClass("additional-insurances") ||
      this.getErrorMessageClass("insurance-questions") ||
      this.getErrorMessageClass("discounts-and-additional-clauses");
  }

  public static getErrorMessageClass(className: string) {
    return !!Widget.getNode(className)?.getElementsByClassName("error-message").item(0);
  }

}
